import { useIdentificationFieldBindings } from "@Client/@Composables/application-standalone/pages/identifications/useIdentificationFieldBindings";
import { useIdentificationFieldVisibility } from "@Client/@Composables/application-standalone/pages/identifications/useIdentificationFieldVisibility";
export const identificationsPageBindingsAndVisibilities = (applicantIndex, identificationIndex, applicantId) => {
  const {
    identificationType,
    identificationCountry,
    identificationNumber
  } = useIdentificationFieldBindings({
    applicantIndex,
    identificationIndex
  });
  const {
    identificationTypeVisible,
    identificationCountryVisible,
    identificationNumberVisible
  } = useIdentificationFieldVisibility({
    applicantIndex,
    identificationIndex,
    applicantId
  });
  return {
    bindings: {
      identificationType,
      identificationCountry,
      identificationNumber
    },
    visibilities: {
      identificationTypeVisible,
      identificationCountryVisible,
      identificationNumberVisible
    }
  };
};